// extracted by mini-css-extract-plugin
export default {"cta":"AE-z","disabled":"BE-z"};